import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(
    private http: HttpClient
  ) { }

  getWalletAmount() {
    return this.http.get(environment.API_URL + `/admin/dashboard/specialUser/walletAmount`).pipe(
      map((res: any) => res.data)
    );
  }
  getPostCountInformation() {
    return this.http.get(environment.API_URL + `/admin/dashboard/specialUser/marketer/postCountInformation`).pipe(
      map((res: any) => res.data)
    );
  }
  getMonthlyPostReport() {
    return this.http.get(environment.API_URL + `/admin/dashboard/specialUser/marketer/monthlyPostReport`).pipe(
      map((res: any) => res.data)
    );
  }
  getContactUs() {
    return this.http.get(environment.API_URL + `/admin/general/contactUs`).pipe(
      map((res: any) => res.data)
    );
  }
}
